<template>
    <VerticalNavigation :items="items"/>
</template>

<script>
import HomeIcon from '../../../../../../components/Icons/Old/HomeIcon'
import BullhornIcon from '../../../../../../components/Icons/Old/BullhornIcon'
import BookReaderIcon from '../../../../../../components/Icons/Old/BookReaderIcon'
import MoneyBillWaveIcon from '../../../../../../components/Icons/Old/MoneyBillWaveIcon'
import VerticalNavigation from '../../../../../../components/VerticalNavigation'

export default {
    components: {VerticalNavigation},

    props: {
        user: {
            required: true
        }
    },

    computed: {
        items() {
            return [
                {name: 'Sales', to: '/users/' + this.user.id, icon: HomeIcon},
                {name: 'Advertising Sales', to: '/users/' + this.user.id + '/dashboard/advertising', icon: BullhornIcon},
                {name: 'Partnership Sales', to: '/users/' + this.user.id + '/dashboard/partnerships', icon: BookReaderIcon},
                {name: 'Commission', to: '/users/' + this.user.id + '/dashboard/commission', icon: MoneyBillWaveIcon}
            ]
        }
    }
}
</script>
